module.exports = __webpack_public_path__ + "media/images/views/lp/home/features/recruiter-263ccd8a7d3d06e847b722c5ba882acb.png";